<template>
    <v-row no-gutters>
        <v-col cols="4">
            <v-card flat class="mx-auto" tile>
                <v-card-title>Update Password</v-card-title>
                <v-card-subtitle>Ensure your account is using a long, random password to stay secure.</v-card-subtitle>
            </v-card>
        </v-col>
        <v-col cols="8" class="justify-center">
            <v-form @submit.prevent="updatePassword">
                <v-card flat>
                    <v-row>
                        <v-col>
                            <v-text-field
                                ref="currentPasswordInput"
                                label="Current Password"
                                autocomplete="current-password"
                                :append-icon="flags.show_current_password ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="flags.show_current_password ? 'text' : 'password'"
                                @click:append="flags.show_current_password = !flags.show_current_password"
                                :error-messages="errors.current_password"
                            />
                            <v-text-field
                                ref="passwordInput"
                                label="New Password"
                                autocomplete="new-password"
                                hint="At least 8 characters"
                                :append-icon="flags.show_password ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="flags.show_password ? 'text' : 'password'"
                                @click:append="flags.show_password = !flags.show_password"
                                :error-messages="errors.password"
                            />
                            <v-text-field
                                type="password"
                                label="Confirm Password"
                                autocomplete="new-password"
                                :error-messages="errors.password_confirmation"
                            />
                            <v-alert
                                v-show="flags.show_success_message"
                                dense
                                text
                                type="success"
                                transition="scale-transition"
                            >
                                Password Updated!
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            depressed
                            color="primary"
                            :disabled="flags.loading"
                        >Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-col>
    </v-row>
</template>

<script>
import _ from "lodash";

export default {
    data() {
        return {
            flags: {
                loading: false,
                show_success_message: false,
                show_current_password: false,
                show_password: false,
            },
            form: this.$inertia.form({
                current_password: '',
                password: '',
                password_confirmation: '',
            }),
            rules: {
                required: value => !!value || 'Required.',
                min: v => (v && v.length >= 8) || 'Min 8 characters',
            },
        };
    },

    methods: {
        updatePassword() {
            this.form.put(route('user-password.update'), {
                errorBag: 'updatePassword',
                preserveScroll: true,
                onSuccess: () => {
                    this.flags.show_success_message = true;
                    this.form.reset();
                    setTimeout(() => this.flags.show_success_message = false, 1000);
                },
                onError: () => {
                    if (this.form.errors.password) {
                        this.form.reset('password', 'password_confirmation');
                        this.$refs.passwordInput.value.focus();
                    }

                    if (this.form.errors.current_password) {
                        this.form.reset('current_password');
                        this.$refs.currentPasswordInput.value.focus();
                    }

                    this.flags.loading = false;
                },
                onFinish: () => this.flags.loading = false,
            });
        }
    },

    computed: {
        errors() {
            return {
                current_password: _.get(this.$page, 'props.errors.current_password', []),
                password: _.get(this.$page, 'props.errors.password', []),
                password_confirmation: _.get(this.$page, 'props.errors.password_confirmation', []),
            };
        }
    },
}
</script>

<style scoped>

</style>
